import React from "react";
import styled from "styled-components";
import { SecondaryButton, PrimaryButton } from "../Button";
import Modal from "../Modal";
import Notification from "../../assets/Notification.svg";

export default function FinishedModal({ isOpen, close, reset }) {
  const handleClick = () => {
    reset();
  };

  return (
    <Modal isOpen={isOpen}>
      <img alt="" src={Notification} />
      <h3>Have you sent your patient's prescription?</h3>
      <p>
        All information will be lost if you click 'I'm finished'. This action
        cannot be undone.
      </p>
      <ButtonContainer>
        <SecondaryButton onClick={() => close()}>Back</SecondaryButton>
        <PrimaryButton onClick={() => handleClick()}>
          I'm finished
        </PrimaryButton>
      </ButtonContainer>
    </Modal>
  );
}

const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  
  button {
    margin-bottom: 0 !important;
  }
`;
